import { render, staticRenderFns } from "./GoalForm.vue?vue&type=template&id=4e5eb497"
import script from "./GoalForm.vue?vue&type=script&lang=ts"
export * from "./GoalForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports